import { NoResults } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";

export type DocumentNoResultProps = {
	hasSearch: boolean;
};

export const DocumentNoResult = (props: DocumentNoResultProps): ReactElement => {
	const { hasSearch } = props;

	return hasSearch
		? (
			<NoResults
				icon="magnifying-glass"
				title={localize("_NoSearchResults")}
				message={localize("_PleaseTrySearchingWithAnotherTerm")}
				height="fill"
			/>
		)
		: (
			<NoResults
				icon="folder-open"
				title={localize("_NoDocumentsToShow")}
				message={localize("_ThereAreCurrentlyNoDocumentsInThisFolder")}
				height="fill"
			/>
		);

};
DocumentNoResult.displayName="DocumentNoResult";
